import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography'
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import { Link } from 'react-router-dom';
import { validateResetPassword } from '../../utils/validator';

const double = 2;
const quintuple = 5;
const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '100vh',
  },

  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    flex: 1,
  },

  form: {
    width: '30%',
    padding: theme.spacing.unit,
    margin: theme.spacing.unit * double,
  },

  item: {
    margin: theme.spacing.unit * double,
    textAlign: 'center',
  },

  bottom: {
    margin: theme.spacing.unit * quintuple,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },

  explaination: {
    margin: '1px 0 24px 0',
    textAlign: 'center',
  },

  formLabel: {
    fontSize: '18px',
  },

  title: {
    fontSize: '24px',
    fontWeight: 800,
  },

  button: {
    margin: '26px 0 0 0',
    backgroundColor: '#1A65FF',
    fontSize: '15px',
    fontWeight: 400,
  },

  link: {
    color: '#1A65FF',
    textDecoration: 'none',
  },
});

class ForgetPassword extends React.Component {
  componentWillReceiveProps(nextProps) {
    this.setState({
      error: Object.assign({}, this.state.error, nextProps.error)
    })
  }

  componentWillUnmount() {
    this.props.resetForgetPassword();
  }

  state = {
    email: '',
    error: {},
  }

  handleChange = property => event => {
    let value = event.target.value;
    this.setState({
      [property]: value,
    });
  };

  handleSubmit = () => {
    let { error, ...requestInfo } = this.state;
    error = this.validateForm();

    if (Object.keys(error).length === 0) {
      this.props.requestPassword(requestInfo);
    }
  }

  validateForm = () => {
    let { error, ...requestInfo } = this.state;
    error = validateResetPassword(requestInfo);

    this.setState({
      error: error,
    });

    return error;
  }

  renderForm = () => {
    const { classes } = this.props;
    const { error } = this.state;

    return (
      <form className={classes.form}>
        <Typography variant="body1" className={classes.explaination}>
          パスワード再発行リンクをご登録のメールアドレスにお送りします。
        </Typography>
        <TextField
          id="email"
          label="メールアドレス"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            disableUnderline: true,
          }}
          placeholder="メールアドレスを入力"
          onChange={this.handleChange('email')}
          error={error.hasOwnProperty('email')}
          helperText={error.email}
          margin="normal"
          fullWidth
          className={classes.row}
        />
        <Button
          color="primary"
          variant="raised"
          fullWidth
          onClick={this.handleSubmit}
          className={classes.button}
        >
          再発行メールを送信
        </Button>
      </form>
    )
  }

  renderUrlRequested = () => {
    const { classes } = this.props;
    return (
      <Typography className={classes.item} style={{ color: '#71737B' }}>リンクの送信を完了しました。</Typography>
    )
  }

  render() {
    const { classes, requested } = this.props;

    let form = this.renderForm();
    let urlRequested = this.renderUrlRequested();

    return (
      <div className={classes.root}>
        <div className={classes.container}>
          <Typography variant="title" className={classes.title}>パスワードをリセット</Typography>
          {requested ? urlRequested : form}
        </div>
        <div className={classes.bottom}>
          <Typography variant="body2" style={{ color: '#71737B' }}><Link to="/signin" className={classes.link}>サインイン</Link></Typography>
        </div>
      </div>
    );
  }
}

ForgetPassword.propTypes = {
  classes: PropTypes.object.isRequired,
  error: PropTypes.object.isRequired,
  requested: PropTypes.bool,
  requestPassword: PropTypes.func,
  resetForgetPassword: PropTypes.func,
};

export default withStyles(styles)(ForgetPassword);



// WEBPACK FOOTER //
// ./src/components/ForgetPassword/ForgetPassword.jsx